'use client';

import { useEffect } from 'react';

export function ServiceWorkerRegistration() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    if (process.env.NODE_ENV !== 'production') {
      // Dev mode: unregister any stale service worker from previous production builds
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        return Promise.all(registrations.map((r) => r.unregister()));
      }).catch(console.warn);
      return;
    }

    navigator.serviceWorker.register('/sw.js').catch(console.warn);
  }, []);

  return null;
}
